<template>
    <div class="content">
        <h2>检验结果告知书</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="140px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="编号:" prop="bh">
                        {{pre}}
                        <el-select v-model="form.lb" size="small" style="width: 80px;">
                            <el-option value="水">水</el-option>
                            <el-option value="学">学</el-option>
                            <el-option value="医">医</el-option>
                            <el-option value="职">职</el-option>
                            <el-option value="传">传</el-option>
                            <el-option value="放">放</el-option>
                            <el-option value="公">公</el-option>
                            <el-option value="血液">血液</el-option>
                            <el-option value="消">消</el-option>
                            <el-option value="计生">计生</el-option>
                            <el-option value="爱">爱</el-option>
                        </el-select>检告字【<el-date-picker style="width:100px;"
                        v-model="form.year"
                        type="year" size="small"
                        placeholder="选择年">
                        </el-date-picker>
                        】
                        <el-input style="width:160px; margin-right:10px;"
                        v-model="form.bh"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getWh">获取文号</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="不合格样品数量:" prop="bhg">
                        <el-radio-group v-model="form.bhg">
                            <el-radio label='0'>全部</el-radio>
                            <el-radio label='1'>部分</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="报告编号:" prop="bgbh">
                        <el-input
                        v-model="form.bgbh"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="联系电话:" prop="lxdh">
                        <el-input
                        v-model="form.lxdh"
                        placeholder=""
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit('form')">生成检验结果告知书</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="检验结果告知书" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    props:['code','pcId'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            jdnr:'',
            form:{
                lb:'',
                year:'',
                bh:'',
                bhg:'0',
                bgbh:'',
                lxdh:'',
            },
            rules:{
                lb:[
                    { required: true, message: '类别不能为空', trigger: ['change','blur'] }
                ],
                bh:[
                    { required: true, message: '编号不能为空', trigger: ['change','blur'] }
                ],
                year:[
                    { required: true, message: '年份不能为空', trigger: ['change','blur'] }
                ],
                bhg:[
                    { required: true, message: '不合格样品数量不能为空', trigger: ['change','blur'] }
                ],
                bgbh:[
                    { required: true, message: '报告编号不能为空', trigger: ['change','blur'] }
                ],
                lxdh:[
                    { required: true, message: '联系电话不能为空', trigger: ['change','blur'] }
                ],
            },
            pre:'',
            isWs:false,
            wsUrl:'',

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            zfXX:[]
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw
        this.getList()
    },
    methods: {
        async getList(){
            
            this.isWs = false
            //判断文书是否存在
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getExistWenshu&id=${this.pcId}&fileName=${escape('检验结果告知书')}&xcblFlag=`)
            if(data.data){
                if(data.data == '1'){
                    //有
                    this.isWs = true
                }
            }
            this.getZfxx()
        },
        async getZfxx(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.wsUrl = ''
            this.docurl = ''
            this.wsPdf = ''
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.pre = data.data[0].wenhaopre
                if(this.isWs){
                    this.wsUrl = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw=jianyanjieguogaozhishu&sjs='+new Date().getTime()
                    console.log(this.wsUrl)
                    let nm = 'jianyanjieguogaozhishu'
                this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()
                
                    this.$set(this.form,'lb',data.data[0].jyjggz_wh01)
                    this.$set(this.form,'year',data.data[0].jyjggz_wh02)
                    this.$set(this.form,'bh',data.data[0].jyjggz_wh03)
                    this.$forceUpdate()
                    console.log(this.form)
                    // this.$set(this.form,'bcfs',arr[1])
                    // this.$set(this.form,'startTime',arr[2])
                    // this.$set(this.form,'endTime',arr[3])
                    // this.$set(this.form,'bcdd',arr[4])
                    // this.$set(this.form,'year',data.data[0].lsh.slice(0,4))
                }
            }
        },
        submit(form){
            let nr = ''
            console.log(this.form)
            nr = escape(this.form.lb) + '|'+this.getDate(this.form.year,'yyyy')+'|'+this.form.bh + '|'+this.form.bhg+ '|' + escape(this.form.bgbh) + '|' + this.form.lxdh 
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    this.loading = true
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "makeWenshu",
                            id: `${this.pcId}`,
                            wsName:escape('检验结果告知书'),
                            shuju: nr,
                            caozuoStatus:1,
                            isOldWenshu:'',
                            wupin:'',
                            gzbm:`${escape(this.gzbm)}`,
                            gzzw:`${escape(this.gzzw)}`,
                            xm:`${escape(this.xm)}`,
                            dm:`${this.dm}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data.code != -1){
                            console.log(res.data.code)
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.wsUrl = res.data.data.split('?')[1]
                            this.show()
                        }else{
                            if(res.data.data){
                                this.$message.error(res.data.data)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        async getWh(){
            if(!this.form.lb || !this.form.year){
                this.$message.error('请先选择专业类别和年份！')
                return false
            }else{
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJyjggzBh&id=${this.pcId}&wh01=${escape(this.form.lb)}&wh02=${this.getDate(this.form.year,'yyyy')}`)
                console.log(data)
                if(data.data){
                    if(data.data.errMessage){
                        this.$set(this.form,'bh',data.data.errMessage)
                    }
                }
            }
        },
        show(){
            console.log(this.wsUrl)
            if(this.wsUrl){
                let mid = this.wsUrl.split('&')[0].replace('mid=','')
                let lsh = this.wsUrl.split('&')[1].replace('lsh=','')
                let wsname = this.wsUrl.split('&')[2].replace('wsnameEw=','')
                let sjs = this.wsUrl.split('&')[3].replace('sjs=','')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:mid,
                        lsh:lsh,
                        wsname:wsname,
                        sjs:sjs
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'jianyanjieguogaozhishu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },

    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>